import api from "../api";
import { Vinculo } from "../model/Pessoa";

export class VinculoViewModel {
    static async getVinculos(): Promise<Vinculo[]> {
        const response = await api.get('/vinculos');
        return response.data;
    }
}
